import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Slider } from 'antd';
import React from 'react'; // 兼容代码-----------

import 'antd/es/slider/style'; //------------

/**
 * 评分组件
 *
 * @param
 */

var FieldSlider = function FieldSlider(_ref, ref) {
  var text = _ref.text,
      mode = _ref.mode,
      render = _ref.render,
      renderFormItem = _ref.renderFormItem,
      fieldProps = _ref.fieldProps;

  if (mode === 'read') {
    var dom = text;

    if (render) {
      return render(text, _objectSpread({
        mode: mode
      }, fieldProps), _jsx(_Fragment, {
        children: dom
      }));
    }

    return _jsx(_Fragment, {
      children: dom
    });
  }

  if (mode === 'edit' || mode === 'update') {
    var _dom = _jsx(Slider, _objectSpread({
      ref: ref
    }, fieldProps));

    if (renderFormItem) {
      return renderFormItem(text, _objectSpread({
        mode: mode
      }, fieldProps), _dom);
    }

    return _dom;
  }

  return null;
};

export default /*#__PURE__*/React.forwardRef(FieldSlider);